export default "__VITE_ASSET__BicBMaot__"